import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { QueryClient } from '@tanstack/react-query';
import { mendoza as arkivMendoza } from '@arkiv-network/sdk/chains';

// Re-export mendoza for use in other files
export const mendoza = arkivMendoza;

import { REOWN_PROJECT_ID } from './config';

// You'll need to get this from https://cloud.reown.com
const projectId = REOWN_PROJECT_ID;

if (!projectId || projectId === '__REOWN_PROJECT_ID__') {
  throw new Error('REOWN_PROJECT_ID environment variable is not set. Please check your .env file.');
}

// Create query client for React Query
export const queryClient = new QueryClient();

// Create wagmi adapter
const wagmiAdapter = new WagmiAdapter({
  networks: [mendoza],
  projectId,
  ssr: false,
});

// Create and configure AppKit
export const appKit = createAppKit({
  adapters: [wagmiAdapter],
  networks: [mendoza],
  projectId,
  metadata: {
    name: 'Business Card Creator',
    description: 'Create and share business cards on Arkiv blockchain',
    url: typeof window !== 'undefined' ? window.location.origin : 'https://localhost:3000',
    icons: ['/icons/icon-192.png'],
  },
  features: {
    analytics: true,
    email: true,
    socials: ['google', 'x', 'discord', 'github'],
  },
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#3b82f6',
    '--w3m-border-radius-master': '8px',
  },
});

export { wagmiAdapter };